import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Portfolio from './pages/Portfolio';
import ArticleDetail from './pages/ArticleDetail';
import Preloader from './components/Preloader';
import SmoothScroll from './components/SmoothScroll';
import ProjectDocumentation from './components/ProjectDocumentation'; // <--- 1. RESTORE IMPORT
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        <Preloader onComplete={handleLoadingComplete} />
      ) : (
        <SmoothScroll>
          <div className="App">
            
            {/* 2. GLOBAL DOCS TRIGGER (Fixed Top-Right) */}
            <ProjectDocumentation /> 

            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Portfolio />} />
                <Route path="/article/:id" element={<ArticleDetail />} />
              </Routes>
            </BrowserRouter>
          </div>
        </SmoothScroll>
      )}
    </>
  );
}

export default App;